import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_NIVELES_ACADEMICOS = 'ALL_NIVELES_ACADEMICOS';
export const ACTIVO_NIVELES_ACADEMICOS = 'ACTIVO_NIVELES_ACADEMICOS';
export const LOADING_ALL_NIVELES_ACADEMICOS = 'LOADING_ALL_NIVELES_ACADEMICOS';
export const PARAMS_NIVELES_ACADEMICOS = 'PARAMS_NIVELES_ACADEMICOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const nivelesAcademicosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_NIVELES_ACADEMICOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_NIVELES_ACADEMICOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_NIVELES_ACADEMICOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_NIVELES_ACADEMICOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
